<template>
  <div class="my-2">
    <div v-if="vesselSubTypeInfo && sectionIndex == null && !currentSection">
      <h4>Ship Image:</h4>
      <div class="image-container w-full pl-0 pr-0 mb-3">
        <img
          ref="shipImg"
          :src="vesselSubTypeInfo.ship_image_url"
          width="1000px"
          height="600px"
          style="min-width: 1000px; max-height: 600px; object-fit: contain"
          alt="vessel-type-image"
          class="cursor-auto"
          @mousemove="isAllowEdit ? handleDragging($event) : voidEvent()"
          @mouseup="isAllowEdit ? stopDragging($event) : voidEvent()"
          @touchend="isAllowEdit ? stopDragging($event) : voidEvent()"
          @touchcancel="isAllowEdit ? stopDragging($event) : voidEvent()"
        />
        <div
          class="legend"
          :style="{ top: top + 'px', right: right + 'px' }"
          v-if="sections.length > 0"
        >
          <div>
            <div
              class="d-flex legend-header justify-content-between align-items-center mover"
              @mousedown="startDrag"
            >
              <h4 class="fs-medium mb-0">Legend</h4>
              <span
                class="fs-small text-info cursor-pointer"
                @click="isShowSectionLegend = !isShowSectionLegend"
                >{{ isShowSectionLegend ? "Hide" : "Show" }}</span
              >
            </div>
            <div class="resizer" v-if="isShowSectionLegend">
              <div v-if="isShowSectionLegend" class="h-100 overflow-auto">
                <hr class="my-1" />
                <div
                  v-for="(section, index) in sections"
                  :key="`legend_${index}`"
                  class="legend-item"
                  :class="{ 'text-warning': !section.location }"
                >
                  {{ index + 1 }} - {{ section.folder_name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="(section, sectionIndex) in mappedSections"
          :key="`section_pin_${sectionIndex}`"
          class="pin"
          :class="
            isAllowEdit && !isDragging
              ? 'cursor-grab'
              : isDragging
              ? 'cursor-move'
              : 'cursor-pointer'
          "
          :style="{
            left: section.location.x + 'px',
            top: section.location.y + 'px',
          }"
          @mousedown="
            isAllowEdit
              ? startDragging(section, $event)
              : openSubFolderView(section)
          "
          @mouseup="isAllowEdit ? stopDragging($event) : voidEvent()"
          @touchend="isAllowEdit ? stopDragging($event) : voidEvent()"
          @touchcancel="isAllowEdit ? stopDragging($event) : voidEvent()"
        >
          <div
            class="text-white"
            :class="section.location.color == 'red' ? 'red-pin' : 'yellow-pin'"
            draggable="true"
          >
            {{ indexFindSection(section) + 1 }}
          </div>
        </div>
      </div>
      <div class="folder-container">
        <div class="flex mt-4 mb-2" v-if="isAllowEdit">
          <h4 class="text-primary">Add Section:</h4>
          <vs-button
            @click="openAddFolder()"
            color="primary"
            icon="add"
            type="border"
            size="small"
            class="ml-3"
          ></vs-button>
        </div>
        <h4 class="text-primary mt4" v-else>Sections:</h4>

        <div class="scroll-container">
          <div
            class="scrollable-content"
            v-for="(section, index) in sections"
            :key="`folder_${index}`"
          >
            <vs-card
              actionable
              class="zoom-effect p-3 position-relative folder-card cursor-default folder-card-bg"
              :class="{
                'bg-warning': !(
                  section.location && section.location.color != 'red'
                ),
              }"
            >
              <div slot="header">
                <div
                  style="position: absolute; top: 0; right: 0"
                  v-if="isAllowEdit"
                >
                  <vs-dropdown vs-trigger-click>
                    <vs-button
                      class="btn-drop text-black"
                      icon="more_vert"
                      type="flat"
                    >
                    </vs-button>
                    <vs-dropdown-menu>
                      <vs-dropdown-item
                        v-if="!section.location"
                        @click="locateMapPin(section, index)"
                      >
                        <span class="text-nowrap"
                          >Map Section</span
                        ></vs-dropdown-item
                      >
                      <vs-dropdown-item
                        v-if="section.location"
                        @click="removeMapPin(section, index)"
                      >
                        <span class="text-nowrap"
                          >Remove Section Map</span
                        ></vs-dropdown-item
                      >
                      <vs-dropdown-item
                        @click="confirmRenameSection(section, index)"
                      >
                        <span class="text-nowrap"
                          >Rename Section</span
                        ></vs-dropdown-item
                      >
                      <vs-dropdown-item
                        v-if="isEnableDelete || !section.id"
                        @click="confirmRemoveSection(section, index)"
                      >
                        <span class="text-nowrap"
                          >Delete Section</span
                        ></vs-dropdown-item
                      >
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
                <div
                  style="position: absolute; top: 0; left: 0"
                  class="p-2 d-flex"
                >
                  <div
                    v-if="checkFolderHasUnmapped(section.subFolders)"
                    class="mr-2"
                  >
                    <vs-icon icon="fiber_manual_record" color="red"></vs-icon>
                  </div>
                  <div v-if="checkFolderHasImage(section.subFolders)">
                    <vs-icon
                      icon="check"
                      :color="folderTickColor(section.subFolders)"
                    ></vs-icon>
                  </div>
                </div>
              </div>
              <div
                class="cursor-pointer folder"
                @click="openSubFolder(section, index)"
              >
                <h4 class="folder-name" :title="section.folder_name">
                  {{ index + 1 }}.{{ section.folder_name }}
                </h4>
                <div v-if="section.file_count != null" class="file-count-label">
                  {{ section.file_count }} images
                </div>
              </div>
            </vs-card>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentSection && sectionIndex > -1 && !folderView">
      <div class="header mb-6">
        <vs-button
          color="dark"
          type="border"
          icon-pack="feather"
          icon="icon-arrow-left"
          class="text-bold"
          size="small"
          @click="goToSectionView()"
          >Back</vs-button
        >
        <div class="w-full justify-right">
          <h2 class="pl-2">Sub Folders</h2>
        </div>
      </div>
      <div>
        <div>
          <h4 class="mb-6">{{ currentSection.folder_name }} - GA Plan Image:</h4>
          <div v-if="!currentSection.ga_plan_image && isAllowEdit" class="relative mb-6">
            <input
              type="file"
              @change="handleFileChange($event)"
              accept="image/*"
              id="custom-file-upload"
              class="hidden"
            />
            <label
              for="custom-file-upload"
              class="block w-full px-8 py-16 text-center cursor-pointer border-2 border-dashed text-xl text-gray-600 d-theme-border-grey-light d-theme-dark-bg hover:bg-gray-100 transition rounded-lg"
            >
              Click to Upload Image
            </label>
          </div>

          <div v-else class="image-container w-full pl-0 pr-0 mb-3">
            <div class="relative">
              <img
                ref="ga_plan_image"
                :src="currentSection.ga_plan_image"
                style="width: 1000px; height: 600px; object-fit: contain"
                alt="ga-plan-image"
                class="cursor-auto"
                @mousemove="
                  isAllowEdit ? handleFolderDragging($event) : voidEvent()
                "
                @mouseup="
                  isAllowEdit ? stopDraggingFolder($event) : voidEvent()
                "
                @touchend="
                  isAllowEdit ? stopDraggingFolder($event) : voidEvent()
                "
                @touchcancel="
                  isAllowEdit ? stopDraggingFolder($event) : voidEvent()
                "
              />
              <div class="absolute m-2 top-0">
                <vs-button
                  color="dark"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-maximize"
                  class="p-0"
                  title="Fullscreen"
                  @click="showImageModal(currentSection.ga_plan_image)"
                ></vs-button>
              </div>
            </div>

            <vs-button
              v-if="isAllowEdit && isInspection"
              @click="deleteGAPlanImage()"
              color="danger"
              icon="delete_forever"
              type="border"
              radius
              size="large"
              class="delete-image"
            ></vs-button>
            <div
              class="legend"
              :style="{ top: top + 'px', right: right + 'px' }"
              v-if="activeFolders(currentSection.subFolders).length > 0"
            >
              <div
                class="d-flex legend-header justify-content-between align-items-center mover"
                @mousedown="startDrag"
              >
                <h4 class="fs-medium mb-0">Legend</h4>
                <span
                  class="fs-small text-info cursor-pointer"
                  @click="isShowFolderLegend = !isShowFolderLegend"
                  >{{ isShowFolderLegend ? "Hide" : "Show" }}</span
                >
              </div>
              <div class="resizer" v-if="isShowFolderLegend">
                <div v-if="isShowFolderLegend" class="h-100 overflow-auto">
                  <hr class="my-1" />
                  <div
                    v-for="(folder, index) in activeFolders(
                      currentSection.subFolders
                    )"
                    :key="`folder_legend_${index}`"
                    class="legend-item"
                    :class="{ 'text-warning': !folder.location }"
                  >
                    {{ indexFindFolder(folder) + 1 }} - {{ folder.folder_name }}
                  </div>
                </div>
              </div>
            </div>
            <div
              v-for="(folder, folderIndex) in mappedFolders"
              :key="`folder_pin_${folderIndex}`"
              class="pin"
              :class="
                isAllowEdit && !isDraggingFolder
                  ? 'cursor-grab'
                  : isDraggingFolder
                  ? 'cursor-move'
                  : 'cursor-pointer'
              "
              :style="{
                left: folder.location.x + 'px',
                top: folder.location.y + 'px',
              }"
              @mousedown="
                isAllowEdit
                  ? startDraggingFolder(folder, $event)
                  : openFolderView(folder)
              "
              @mouseup="isAllowEdit ? stopDraggingFolder($event) : voidEvent()"
              @touchend="isAllowEdit ? stopDraggingFolder($event) : voidEvent()"
              @touchcancel="
                isAllowEdit ? stopDraggingFolder($event) : voidEvent()
              "
            >
              <div
                class="text-white"
                :class="
                  folder.location.color == 'red' ? 'red-pin' : 'yellow-pin'
                "
                draggable="true"
              >
                {{ indexFindFolder(folder) + 1 }}
              </div>
            </div>
          </div>
        </div>
        <div class="folder-container">
          <div class="flex mt-4 mb-2" v-if="isAllowEdit">
            <h4 class="text-primary">Add Sub Folder:</h4>
            <vs-button
              @click="openAddSubFolder()"
              color="primary"
              icon="add"
              type="border"
              size="small"
              class="ml-3"
            ></vs-button>
          </div>
          <h4 class="text-primary mt-4" v-else>Sub Folders:</h4>

          <div class="scroll-container">
            <div
              class="scrollable-content"
              v-for="(folder, index) in activeFolders(
                currentSection.subFolders
              )"
              :key="`folder_${index}`"
            >
              <vs-card
                class="zoom-effect p-3 position-relative folder-card folder-card-bg"
                :class="{
                  'bg-warning': !(
                    folder.location && folder.location.color != 'red'
                  ),
                }"
                style="position: relative"
              >
                <div slot="header">
                  <div
                    style="position: absolute; top: 0; right: 0"
                    v-if="isAllowEdit"
                  >
                    <vs-dropdown vs-trigger-click>
                      <vs-button
                        class="btn-drop text-black"
                        icon="more_vert"
                        type="flat"
                      >
                      </vs-button>
                      <vs-dropdown-menu>
                        <vs-dropdown-item
                          v-if="!folder.location"
                          @click="locateFolderMapPin(folder, index)"
                        >
                          <span class="text-nowrap"
                            >Map Folder</span
                          ></vs-dropdown-item
                        >
                        <vs-dropdown-item
                          v-if="folder.location"
                          @click="removeFolderMapPin(folder, index)"
                        >
                          <span class="text-nowrap"
                            >Remove Folder Map</span
                          ></vs-dropdown-item
                        >
                        <vs-dropdown-item
                          @click="confirmRenameFolder(folder, index)"
                        >
                          <span class="text-nowrap"
                            >Rename Folder</span
                          ></vs-dropdown-item
                        >
                        <vs-dropdown-item
                          v-if="isEnableDelete || !folder.id"
                          @click="confirmRemoveFolder(folder, index)"
                        >
                          <span class="text-nowrap"
                            >Delete Folder</span
                          ></vs-dropdown-item
                        >
                        <vs-dropdown-item
                          v-if="!isEnableDelete && folder.id"
                          @click="confirmArchiveFolder(folder, index)"
                        >
                          <span class="text-nowrap"
                            >Archive Folder</span
                          ></vs-dropdown-item
                        >
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                  <div
                    v-if="folder.file_count > 0"
                    style="position: absolute; top: 0; left: 0"
                    class="p-2"
                  >
                    <vs-icon icon="check" color="success"></vs-icon>
                  </div>
                </div>
                <div
                  class="cursor-pointer folder"
                  @click="openFolderView(folder)"
                >
                  <h4 class="folder-name" :title="folder.folder_name">
                    {{ index + 1 }}.{{ folder.folder_name }}
                  </h4>
                  <div v-if="folder.file_count != null" class="file-count-label">
                    {{ folder.file_count }} images
                  </div>
                </div>
              </vs-card>
            </div>
          </div>

          <div
            v-if="archiveFolders(currentSection.subFolders).length && isAdmin"
          >
            <h4 class="text-primary">Archive Folders:</h4>
            <div class="scroll-container">
              <div
                class="scrollable-content"
                v-for="(folder, index) in archiveFolders(
                  currentSection.subFolders
                )"
                :key="`folder_${index}`"
              >
                <vs-card
                  class="zoom-effect p-3 position-relative folder-card"
                  :class="{
                    'bg-warning': !(
                      folder.location && folder.location.color != 'red'
                    ),
                  }"
                  style="position: relative"
                >
                  <div slot="header">
                    <div style="position: absolute; top: 0; right: 0">
                      <vs-dropdown vs-trigger-click>
                        <vs-button
                          class="btn-drop text-black"
                          icon="more_vert"
                          type="flat"
                        >
                        </vs-button>
                        <vs-dropdown-menu>
                          <vs-dropdown-item
                            v-if="!isEnableDelete"
                            @click="confirmUnArchiveFolder(folder, index)"
                          >
                            <span class="text-nowrap"
                              >Undo Archive Folder</span
                            ></vs-dropdown-item
                          >
                        </vs-dropdown-menu>
                      </vs-dropdown>
                    </div>
                  </div>
                  <div
                    class="cursor-pointer folder"
                    @click="openFolderView(folder)"
                  >
                    <h4 class="folder-name" :title="folder.folder_name">
                      {{ index + 1 }}.{{ folder.folder_name }}
                    </h4>
                    <div v-if="folder.file_count != null" class="file-count-label">
                      {{ folder.file_count }} images
                    </div>
                  </div>
                </vs-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="folderView">
      <div class="d-flex align-items-center">
        <vs-button
          type="flat"
          icon="arrow_back"
          class="mr-1"
          @click="folderView = null"
        ></vs-button>
        <h3 class="text-primary mb-0">{{ folderView.folder_name }}</h3>
      </div>
      <div>
        <div
          v-if="currentImage"
          class="relative w-full h-full"
          style="min-height: 600px"
        >
          <div class="absolute m-3" style="top: 50%">
            <vs-button
              v-if="!(currentImage.index === 0)"
              radius
              class="opacity-75"
              color="primary"
              @click="changeImage(-1)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="7"
                stroke="currentColor"
                class="w-6 h-6 text-white"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 19.5 8.25 12l7.5-7.5"
                />
              </svg>
            </vs-button>
          </div>

          <div class="text-center">
            <img
              v-if="!loadingImage"
              :src="currentImage.url"
              :key="currentImage.url"
              @load="loadingImage = false"
              @error="loadingImage = false"
              loading="lazy"
              style="height: 600px; object-fit: contain"
              width="100%"
              class="mb-1"
              :id="`folder_image_${folderView.folder_name}`"
            />
            <p v-if="currentImage.name" class="text-muted mb-2 viewer-filename">
              {{ currentImage.name }}
            </p>
          </div>

          <div class="absolute m-2 top-0 right-0">
            <div class="d-flex">
              <vs-button
                color="dark"
                type="filled"
                icon-pack="feather"
                icon="icon-download"
                class="mr-1"
                title="Download"
                @click="downloadIMG(currentImage.url)"
              >
              </vs-button>
              <vs-button
                color="dark"
                type="filled"
                icon-pack="feather"
                icon="icon-maximize"
                class="p-0"
                title="Fullscreen"
                @click="showImageModal(currentImage.url)"
              >
              </vs-button>
            </div>
          </div>

          <div class="absolute m-3" style="top: 50%; right: 0px">
            <vs-button
              v-if="!(currentImage.index === folderView.files.length - 1)"
              radius
              class="opacity-75"
              color="primary"
              @click="changeImage(1)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="7"
                stroke="currentColor"
                class="w-6 h-6 text-white"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m8.25 4.5 7.5 7.5-7.5 7.5"
                />
              </svg>
            </vs-button>
          </div>
        </div>
        <p
          v-if="folderView.files && folderView.files.length == 0"
          class="text-muted text-center h3 mt-4 pt-4"
        >
          No Images Available
        </p>
        <div class="scroll-container py-2">
          <div class="scrollable-content">
            <vs-card
              class="zoom-effect p-3 position-relative mb-1 text-center image-card position-relative"
              style="position: relative"
              v-for="(file, imageIndex) in folderView.files"
              :key="`file_${imageIndex}`"
              :class="{
                'border border-primary':
                  currentImage != null && currentImage.index == imageIndex,
              }"
            >
              <div class="h-100">
                <img
                  :src="file.thumbnail"
                  alt="ThumbnailImage"
                  class="image m-auto cursor-pointer"
                  @click="showFullImage(file, imageIndex)"
                  :id="`${folderView.folder_name}_${imageIndex}`"
                />
                <span
                  class="remove-btn"
                  v-if="!isUserType('CL') && !file.isUploading"
                  @click="removeFile(file, imageIndex)"
                  >x</span
                >
              </div>
              <p class="mb-0 text-muted" v-if="file.isUploading">
                Uploading...
              </p>
              <p
                v-else
                class="mb-0 mt-1 text-center text-muted thumbnail-filename"
                :title="getImageName(file.original || file.thumbnail)"
              >
                SID{{ String(imageIndex + 1).padStart(3, '0') }} - {{ getImageName(file.original || file.thumbnail) }}
              </p>
            </vs-card>
          </div>
        </div>
        <div class="w-full mt-10" v-if="inspectionMode && isAllowEdit">
          <div
            class="w-full min-h-[900px] flex items-center justify-center"
            @dragover.prevent="onDragOver"
            @dragleave="onDragLeave"
            @drop.prevent="onDrop($event, folderView)"
          >
            <div
              class="w-full border-2 border-dashed rounded-lg p-20 bg-white shadow-md transition-all duration-200 ease-in-out text-center cursor-pointer hover:bg-blue-50 relative"
              :class="{ 'border-dark bg-blue-50': isDragOver }"
              @click="openFileDialog"
            >
              <!-- Hidden file input -->
              <input
                ref="fileInput"
                type="file"
                :id="`file_input_${folderView.folder_name}`"
                class="hidden"
                multiple
                accept=".jpg, .jpeg"
                @change="handleFileUpload($event, folderView)"
              />

              <!-- Upload Icon and Text -->
              <div class="flex flex-col items-center justify-center space-y-2">
                <feather-icon
                  icon="UploadIcon"
                  svgClasses="w-8 h-8 stroke-current text-dark"
                />
                <div class="font-medium text-lg font-bold text-dark">
                  Upload Image - {{ folderView.folder_name }}
                </div>
                <div class="text-sm font-bold">
                  Click or drag and drop files here
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div>
          <div class="fixed-card" v-if="inspectionMode">
            <div
              class="image-card text-center position-relative"
              @dragover.prevent="onDragOver"
              @dragleave="onDragLeave"
              @drop.prevent="onDrop($event, folderView)"
              :class="{ 'drag-over': isDragOver }"
            >
              <vs-card
                class="zoom-effect p-3 position-relative mb-1 text-center h-100 align-content-center"
                style="position: relative"
              >
                <div class="cursor-pointer" @click="openFileDialog">
                  <input
                    ref="fileInput"
                    type="file"
                    :id="`file_input_${folderView.folder_name}`"
                    class="custom-input-image"
                    multiple
                    accept=".jpg, .jpeg"
                    @change="handleFileUpload($event, folderView)"
                  />
                  <div>
                    <i class="fas fa-camera fa-2x d-block"></i>
                    <div class="grid">
                      <label>Upload Image</label>
                      <label>or Drag and Drop</label>
                    </div>
                  </div>
                </div>
              </vs-card>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <vs-popup
      v-if="folderNamePopup.isShow"
      :title="folderNamePopup.title"
      class="another-popup"
      :active.sync="folderNamePopup.isShow"
    >
      <div class="vx-row w-full m-0 mb-4">
        <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">
          <label>{{ folderNamePopup.message }}</label>
          <vs-input
            v-if="
              ['performUpdate', 'performUpdateFolder'].includes(
                folderNamePopup.action
              )
            "
            type="text"
            maxlength="50"
            class="w-full mt-1"
            name="name"
            v-model="folderNamePopup.data"
            icon-no-border
          />
        </div>
      </div>
      <div class="flex justify-end mt-4">
        <vs-button type="border" @click="cancelFolderNamePopup">{{
          folderNamePopup.buttons[0]
        }}</vs-button>

        <vs-button
          class="ml-5"
          color="primary"
          v-if="['performUpdate'].includes(folderNamePopup.action)"
          @click="performUpdate(folderNamePopup.buttons[1])"
          >{{ folderNamePopup.buttons[1] }}</vs-button
        >
        <vs-button
          class="ml-5"
          color="primary"
          v-if="['performUpdateFolder'].includes(folderNamePopup.action)"
          @click="performUpdateFolder(folderNamePopup.buttons[1])"
          >{{ folderNamePopup.buttons[1] }}</vs-button
        >
        <vs-button
          class="ml-5"
          color="primary"
          v-if="folderNamePopup.action == 'removePin'"
          @click="removePin(folderNamePopup.info)"
          >{{ folderNamePopup.buttons[1] }}</vs-button
        >
        <vs-button
          class="ml-5"
          color="primary"
          v-if="folderNamePopup.action == 'removeMapPinFolder'"
          @click="removeMapPinFolder(folderNamePopup.info)"
          >{{ folderNamePopup.buttons[1] }}</vs-button
        >
        <vs-button
          class="ml-5"
          color="primary"
          v-if="folderNamePopup.action == 'deleteFolder'"
          @click="deleteFolder(folderNamePopup.info)"
          >{{ folderNamePopup.buttons[1] }}</vs-button
        >
        <vs-button
          class="ml-5"
          color="primary"
          v-if="folderNamePopup.action == 'archiveFolder'"
          @click="archiveFolder(folderNamePopup.info)"
          >{{ folderNamePopup.buttons[1] }}</vs-button
        >
        <vs-button
          class="ml-5"
          color="primary"
          v-if="folderNamePopup.action == 'activeFolder'"
          @click="activeFolder(folderNamePopup.info)"
          >{{ folderNamePopup.buttons[1] }}</vs-button
        >
        <vs-button
          class="ml-5"
          color="primary"
          v-if="folderNamePopup.action == 'deleteSection'"
          @click="deleteSection(folderNamePopup.info)"
          >{{ folderNamePopup.buttons[1] }}</vs-button
        >
        <vs-button
          class="ml-5"
          color="primary"
          v-if="folderNamePopup.action == 'locatePins'"
          @click="locatePins(folderNamePopup.info)"
          >{{ folderNamePopup.buttons[1] }}</vs-button
        >
        <vs-button
          class="ml-5"
          color="primary"
          v-if="folderNamePopup.action == 'locateFolderPins'"
          @click="locateFolderPins(folderNamePopup.info)"
          >{{ folderNamePopup.buttons[1] }}</vs-button
        >
        <vs-button
          class="ml-5"
          color="primary"
          v-if="folderNamePopup.action == 'deleteGAPlan'"
          @click="deleteGAPlan()"
          >{{ folderNamePopup.buttons[1] }}</vs-button
        >
        <vs-button
          class="ml-5"
          color="primary"
          v-if="folderNamePopup.action == 'deleteInsImage'"
          @click="deleteInsImage(folderNamePopup.info)"
          >{{ folderNamePopup.buttons[1] }}</vs-button
        >
      </div>
    </vs-popup>
    <ImageModal
      :isVisible="imageModal.isShow"
      :imageUrl="imageModal.url"
      @close="closeImageModal"
    />
  </div>
</template>
<script>
import Vue from "vue";
import ImageModal from "@/layouts/image-modal.vue";
export default {
  components: {
    ImageModal,
  },
  props: {
    sectionInfo: {
      type: Array,
      default: () => [],
    },
    vesselSubTypeInfo: {
      type: Object,
      default: null,
    },
    project: {
      type: Object,
      default: null,
    },
    page: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      sections: [],
      folderNamePopup: {
        title: "Add Folder",
        message: "Folder Name",
        action: null,
        isShow: false,
        data: null,
      },
      isDragging: false,
      draggingIndex: null,
      sectionIndex: null,
      isDraggingFolder: false,
      draggingFolderIndex: null,
      folderView: null,
      currentImage: null,
      selectedImages: [],
      isShowSectionLegend: false,
      isShowFolderLegend: false,
      sliderImageIndex: 0,

      dragging: false,
      top: 0,
      right: 0,
      startX: 0,
      startY: 0,
      imageModal: {
        isShow: false,
        url: null,
      },
      isFormDirty: false,
      isDragOver: false,
      loadingImage: false,
    };
  },
  computed: {
    isAdmin() {
      return this.isUserType("A");
    },
    mappedSections() {
      return this.sections.filter((v) => v.location) || [];
    },
    currentSection() {
      return this.sectionIndex > -1 ? this.sections[this.sectionIndex] : null;
    },
    mappedFolders() {
      return this.currentSection
        ? this.currentSection.subFolders.filter(
            (v) => v.location && v.status != "N"
          )
        : [];
    },
    isAllowEdit() {
      // Clients are always read-only here, regardless of which page renders
      // this component (previously this only checked `page`, which meant a
      // Client landing on the "inspection" page would get full edit rights).
      if (this.isUserType("CL")) return false;

      return this.page
        ? ["addEditVessel", "addEditProject", "inspection"].includes(this.page)
        : true;
    },
    isInspection() {
      return this.page === "inspection";
    },
    viewMode() {
      return !this.isAllowEdit && ["viewProject"].includes(this.page);
    },
    inspectionMode() {
      return ["inspection"].includes(this.page);
    },
    isEnableDelete() {
      return this.project
        ? ["C", "DR"].includes(this.project.status) || this.isInspection
        : false;
    },
    isShowFolderView() {
      return this.project && this.project.id;
    },
    getFiles() {
      return this.folderView && this.folderView.files
        ? this.folderView.files
        : [];
    },
    getOriginalImageUrlWithIndex() {
      if (!this.folderView || !Array.isArray(this.folderView.files)) return [];

      return this.folderView.files
        .map((file, index) => {
          const url = file.original || file.thumbnail;
          return {
            url,
            index,
            name: `SID${String(index + 1).padStart(3, '0')} - ${this.getImageName(url)}`,
          };
        })
        .filter((item) => item.url);
    },
  },
  mounted() {
    this.initSetup(this.sectionInfo);
  },
  watch: {
    sectionInfo(val) {
      this.initSetup(val);
    },
  },
  methods: {
    onDragOver() {
      this.isDragOver = true;
    },
    onDragLeave() {
      this.isDragOver = false;
    },
    onDrop(event, folderView) {
      console.log("drag over");
      console.log(event);
      const e = {
        ...event,
        target: { ...event.target, files: event.dataTransfer.files },
      };
      this.handleFileUpload(e, folderView);
    },
    setFormDirty() {
      this.isFormDirty = true;
    },
    checkFolderHasImage(folders) {
      return folders.some((v) => v.file_count && v.file_count > 0);
    },
    checkFolderHasUnmapped(folders) {
      return folders.some((v) => !v.location);
    },
    folderTickColor(folders) {
      return folders.some((v) => !v.file_count || v.file_count == 0)
        ? "danger"
        : "success";
    },
    closeImageModal() {
      this.imageModal.isShow = false;
    },
    initSetup(data) {
      this.sections = data.map((v, index) => ({
        ...v,
        index,
        _id: `${Date.now()}${Math.floor(Math.random() * 100)}`,
        subFolders: v.subFolders.map((s, sindex) => ({
          ...s,
          index: sindex,
          _id: `${Date.now()}${Math.floor(Math.random() * 100)}`,
        })),
      }));
    },
    openAddFolder() {
      this.folderNamePopup.title = "Add Section";
      this.folderNamePopup.message = "Section Name";
      this.folderNamePopup.action = "performUpdate";
      this.folderNamePopup.buttons = ["cancel", "Create"];
      this.folderNamePopup.data = null;
      this.folderNamePopup.isShow = true;
    },
    openAddSubFolder() {
      this.folderNamePopup.title = "Add Sub Folder";
      this.folderNamePopup.message = "Folder Name";
      this.folderNamePopup.action = "performUpdateFolder";
      this.folderNamePopup.buttons = ["cancel", "Create"];
      this.folderNamePopup.data = null;
      this.folderNamePopup.isShow = true;
      this.folderNamePopup.info = {
        index: this.sectionIndex,
        section: this.currentSection,
      };
    },
    locateMapPin(section, index) {
      this.folderNamePopup.title = "Map Section";
      this.folderNamePopup.message = "Are you confirm want to Map Section?";
      this.folderNamePopup.action = "locatePins";
      this.folderNamePopup.info = {
        index,
        section,
      };
      this.folderNamePopup.buttons = ["Cancel", "Confirm"];
      this.folderNamePopup.isShow = true;
    },
    locateFolderMapPin(folder, index) {
      this.folderNamePopup.title = "Map Folder";
      this.folderNamePopup.message = "Are you confirm want to Map Folder?";
      this.folderNamePopup.action = "locateFolderPins";
      this.folderNamePopup.info = {
        index,
        folder,
      };
      this.folderNamePopup.buttons = ["Cancel", "Confirm"];
      this.folderNamePopup.isShow = true;
    },
    removeMapPin(section, index) {
      this.folderNamePopup.title = "Remove Section Map";
      this.folderNamePopup.message =
        "Are you confirm want to Remove Section Map?";
      this.folderNamePopup.action = "removePin";
      this.folderNamePopup.info = {
        index,
        section,
      };
      this.folderNamePopup.buttons = ["Cancel", "Confirm"];
      this.folderNamePopup.isShow = true;
    },
    removeFolderMapPin(folder, index) {
      this.folderNamePopup.title = "Remove Folder Map";
      this.folderNamePopup.message =
        "Are you confirm want to Remove Folder Map?";
      this.folderNamePopup.action = "removeMapPinFolder";
      this.folderNamePopup.info = {
        index,
        folder,
      };
      this.folderNamePopup.buttons = ["Cancel", "Confirm"];
      this.folderNamePopup.isShow = true;
    },
    confirmRenameSection(section, index) {
      this.folderNamePopup.isShow = true;
      this.folderNamePopup.action = "performUpdate";
      this.folderNamePopup.title = "Rename Section";
      this.folderNamePopup.message = "Folder Name";
      this.folderNamePopup.data = section.folder_name;
      this.folderNamePopup.buttons = ["Cancel", "Update"];
      this.folderNamePopup.info = {
        index,
        section,
      };
    },
    confirmRenameFolder(folder, index) {
      this.folderNamePopup.isShow = true;
      this.folderNamePopup.action = "performUpdateFolder";
      this.folderNamePopup.title = "Rename Section";
      this.folderNamePopup.message = "Folder Name";
      this.folderNamePopup.data = folder.folder_name;
      this.folderNamePopup.buttons = ["Cancel", "Update"];
      this.folderNamePopup.info = {
        index,
        folder,
      };
    },
    confirmRemoveSection(section, index) {
      this.folderNamePopup.title = "Delete Section";
      this.folderNamePopup.message = "Are you confirm want to Remove Section?";
      this.folderNamePopup.action = "deleteSection";
      this.folderNamePopup.info = {
        index,
        section,
      };
      this.folderNamePopup.buttons = ["Cancel", "Delete"];
      this.folderNamePopup.isShow = true;
    },
    confirmRemoveFolder(folder, index) {
      this.folderNamePopup.title = "Delete Folder";
      this.folderNamePopup.message = "Are you confirm want to Remove Folder?";
      this.folderNamePopup.action = "deleteFolder";
      this.folderNamePopup.info = {
        index,
        folder,
      };
      this.folderNamePopup.buttons = ["Cancel", "Delete"];
      this.folderNamePopup.isShow = true;
    },
    confirmArchiveFolder(folder, index) {
      this.folderNamePopup.title = "Archive Folder";
      this.folderNamePopup.message = "Are you confirm want to Archive Folder?";
      this.folderNamePopup.action = "archiveFolder";
      this.folderNamePopup.info = {
        index,
        folder,
      };
      this.folderNamePopup.buttons = ["Cancel", "Archive"];
      this.folderNamePopup.isShow = true;
    },
    confirmUnArchiveFolder(folder, index) {
      this.folderNamePopup.title = "Undo Archive Folder";
      this.folderNamePopup.message = "Are you confirm want to Active Folder?";
      this.folderNamePopup.action = "activeFolder";
      this.folderNamePopup.info = {
        index,
        folder,
      };
      this.folderNamePopup.buttons = ["Cancel", "Active"];
      this.folderNamePopup.isShow = true;
    },
    async performUpdate(action) {
      this.setFormDirty();
      const folder_name = this.folderNamePopup.data;
      const isEdit = action == "Update";
      const folderIndex = this.folderNamePopup.index;
      const hasSameFolder = this.sections.some(
        (v, index) =>
          v.folder_name === folder_name &&
          (isEdit ? index != folderIndex : true)
      );
      if (hasSameFolder) {
        this.$vs.notify({
          title: "Error.",
          text: "Same Folder Name is already exists",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!isEdit) {
        this.sections.push({
          folder_name,
          location: null,
          subFolders: [],
          index: this.sections.length,
          _id: `${Date.now()}${Math.floor(Math.random() * 100)}`,
        });
      } else {
        const index = this.folderNamePopup.info.index;
        this.sections[index].folder_name = folder_name;
      }
      this.folderNamePopup.isShow = false;
    },
    performUpdateFolder(action) {
      this.setFormDirty();
      const folder_name = this.folderNamePopup.data;
      const isEdit = action == "Update";
      const folderIndex = this.folderNamePopup.index;
      const hasSameFolder =
        this.currentSection.subFolders &&
        this.currentSection.subFolders.some(
          (v, index) =>
            v.folder_name === folder_name &&
            (isEdit ? index != folderIndex : true)
        );
      if (hasSameFolder) {
        this.$vs.notify({
          title: "Error.",
          text: "Same Folder Name is already exists",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!isEdit) {
        this.sections[this.sectionIndex].subFolders.push({
          folder_name,
          location: null,
          index: this.sections[this.sectionIndex].subFolders.length,
          _id: `${Date.now()}${Math.floor(Math.random() * 100)}`,
        });
      } else {
        const info = this.folderNamePopup.info;
        const _id = info.folder._id;
        const index = this.sections[this.sectionIndex].subFolders.findIndex(
          (v) => v._id === _id
        );

        this.sections[this.sectionIndex].subFolders[index].folder_name =
          folder_name;
      }
      this.folderNamePopup.isShow = false;
    },
    removePin(info) {
      this.setFormDirty();
      const index = info.index;
      this.sections[index].location = null;
      this.folderNamePopup.isShow = false;
    },
    removeMapPinFolder(info) {
      this.setFormDirty();
      const _id = info.folder._id;
      const index = this.sections[this.sectionIndex].subFolders.findIndex(
        (v) => v._id === _id
      );
      this.sections[this.sectionIndex].subFolders[index].location = null;
      this.folderNamePopup.isShow = false;
    },
    deleteFolder(info) {
      this.setFormDirty();
      if (info != null) {
        const _id = info.folder._id;
        const index = this.sections[this.sectionIndex].subFolders.findIndex(
          (v) => v._id === _id
        );

        this.sections[this.sectionIndex].subFolders.splice(index, 1);
      }
      this.folderNamePopup.isShow = false;
    },
    archiveFolder(info) {
      if (info != null) {
        const folder = info.folder;
        this.changeSubFolderStatus("N", folder);
      }
      this.folderNamePopup.isShow = false;
    },
    activeFolder(info) {
      if (info != null) {
        const folder = info.folder;
        this.changeSubFolderStatus("Y", folder);
      }
      this.folderNamePopup.isShow = false;
    },
    deleteSection(info) {
      this.setFormDirty();
      if (info != null) {
        const index = info.index;
        this.sections.splice(index, 1);
      }
      this.folderNamePopup.isShow = false;
    },
    locatePins(info) {
      this.setFormDirty();
      const a = {
        x: 50,
        y: 50,
        color: "red",
      };
      const element = this.$refs.shipImg;
      if (element) {
        a.x = element.clientWidth - 20;
        a.y = element.clientHeight - 20;
      }
      const index = info.index;
      this.folderNamePopup.isShow = false;
      Vue.set(this.sections[index], "location", a);
    },
    locateFolderPins(info) {
      this.setFormDirty();
      const a = {
        x: 50,
        y: 50,
        color: "red",
      };
      const element = this.$refs.ga_plan_image;
      if (element) {
        a.x = element.clientWidth - 20;
        a.y = element.clientHeight - 20;
      }
      const _id = info.folder._id;
      const index = this.sections[this.sectionIndex].subFolders.findIndex(
        (v) => v._id === _id
      );
      this.folderNamePopup.isShow = false;
      Vue.set(
        this.sections[this.sectionIndex].subFolders[index],
        "location",
        a
      );
    },
    cancelFolderNamePopup() {
      this.folderNamePopup.isShow = false;
    },
    voidEvent() {
      return;
    },
    handleDragging(event) {
      if (this.isDragging && this.draggingIndex !== -1) {
        const marker = this.sections[this.draggingIndex];
        const x = event.clientX - this.initialX;
        const y = event.clientY - this.initialY;
        // Boundaries for marker
        const minX = 0;
        const minY = 0;
        const maxX = 998;
        const maxY = 598;
        marker.location.x = Math.max(minX, Math.min(maxX, x));
        marker.location.y = Math.max(minY, Math.min(maxY, y));
      }
    },
    startDragging(section, event) {
      event.preventDefault();
      this.isDragging = true;
      const _id = section._id;
      const index = this.sections.findIndex((v) => v._id === _id);
      this.draggingIndex = index;
      const marker = section;

      this.initialX = event.clientX - marker.location.x;
      this.initialY = event.clientY - marker.location.y;
    },

    stopDragging(event) {
      if (this.isDragging) {
        this.setFormDirty();
        this.sections[this.draggingIndex].location.color = "yellow";
        this.isDragging = false;
        this.draggingIndex = -1;
      }
    },
    openSubFolder(section, index) {
      this.sectionIndex = index;
    },
    openSubFolderView(section) {
      if (["viewProject"].includes(this.page)) {
        const index = this.indexFindSection(section);
        this.sectionIndex = index;
      }
      return;
    },
    goToSectionView() {
      this.sectionIndex = null;
    },
    handleFolderDragging(event) {
      if (this.isDraggingFolder) {
        const marker = this.currentSection.subFolders[this.draggingFolderIndex];
        const x = event.clientX - this.initialX;
        const y = event.clientY - this.initialY;
        // Boundaries for marker
        const minX = 0;
        const minY = 0;
        const maxX = 998;
        const maxY = 748;
        marker.location.x = Math.max(minX, Math.min(maxX, x));
        marker.location.y = Math.max(minY, Math.min(maxY, y));
      }
    },
    stopDraggingFolder(event) {
      this.setFormDirty();
      if (this.isDraggingFolder) {
        this.sections[this.sectionIndex].subFolders[
          this.draggingFolderIndex
        ].location.color = "yellow";
        this.isDraggingFolder = false;
        this.draggingFolderIndex = -1;
      }
    },
    startDraggingFolder(folder, event) {
      event.preventDefault();
      this.isDraggingFolder = true;
      this.draggingFolderIndex = this.indexFindFolder(folder);
      const marker = folder;
      this.initialX = event.clientX - marker.location.x;
      this.initialY = event.clientY - marker.location.y;
    },
    handleFileChange(event) {
      const file = event.target.files[0]; // Get the selected file
      this.setFormDirty();
      if (file) {
        this.sections[this.sectionIndex].file = file;
        this.sections[this.sectionIndex].ga_plan_image =
          URL.createObjectURL(file);
      }
    },
    deleteGAPlanImage() {
      this.folderNamePopup.title = "Delete Image";
      this.folderNamePopup.message =
        "Are you confirm want to Delete GA Plan Image?";
      this.folderNamePopup.action = "deleteGAPlan";
      this.folderNamePopup.info = null;
      this.folderNamePopup.buttons = ["Cancel", "Delete"];
      this.folderNamePopup.isShow = true;
    },
    deleteGAPlan() {
      this.setFormDirty();
      Vue.set(this.sections[this.sectionIndex], "file", null);
      Vue.set(this.sections[this.sectionIndex], "ga_plan_image", null);
      this.folderNamePopup.isShow = false;
      this.sections[this.sectionIndex].subFolders = this.sections[
        this.sectionIndex
      ].subFolders.map((v) => ({
        ...v,
        location: null,
      }));
    },
    openFolderView(folder) {
      if (!this.project) {
        return;
      }
      this.currentImage = null;
      if (!folder.id) {
        this.$vs.notify({
          title: "Error.",
          text: "Please click save before enter into image upload",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.isShowFolderView) {
        this.folderView = { ...folder, files: folder.files || [] };
        if (folder.id) {
          this.getSubFolderFiles(folder);
        }
      }
    },
    async getSubFolderFiles(folder) {
      this.currentImage = null;
      this.sliderImageIndex = 0;
      const project_id = this.project ? this.project.id : null;
      const folder_id = folder.id;
      this.$vs.loading();
      const response = await this.getHTTPGetResponse(
        `projects/${project_id}/subfolder/${folder_id}/image`
      );
      this.$vs.loading.close();
      if (response && response.status == "200" && response.data) {
        const images = response.data.images;
        if (images.length) {
          this.currentImage = {
            url: images[0].original,
            index: 0,
            name: `SID001 - ${this.getImageName(images[0].original)}`,
          };
        } else {
          this.currentImage = null;
        }
        this.folderView = {
          ...this.folderView,
          files: response.data.images,
        };
      }
    },
    async handleFileUpload(event, subFolder) {
      this.setFormDirty();
      const files = event.target.files;
      this.selectedImages = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const url = URL.createObjectURL(file);
        this.selectedImages.push({
          url,
          name: file.name,
          file,
        });
        this.folderView.files.unshift({
          thumbnail: url,
          original: url,
          isUploading: true,
          index: i,
        });
      }
      if (!subFolder.id) {
        const subObj = await this.createSubFolder();
        if (subObj) {
          const sub = subObj.subFolders.find(
            (v) => v.folder_name === subFolder.folder_name
          );
          subFolder.id = sub.id;
          this.folderView.id = sub.id;
          const newSectionObj = {
            ...subObj,
            _id: this.generateRandomID(),
            subFolders: subObj.subFolders.map((v) => ({
              ...v,
              _id: this.generateRandomID(),
            })),
          };
          this.sections[this.sectionIndex] = newSectionObj;
        }
      }
      for (let j = 0; j < files.length; j++) {
        const file = files[j];
        this.uploadImages(file, j, subFolder);
      }
      this.$refs.fileInput.value = null;
    },
    async createSubFolder() {
      const sectionData = this.currentSection;
      const project = this.project;
      const project_id = project ? project.id : null;
      const vessel_id = project ? project.vessel_id : null;
      const foldersPayload = [
        {
          id: sectionData.id || null,
          folder_name: sectionData.folder_name,
          imageBlob: sectionData.file || null,
          ga_plan_image: sectionData.file ? null : sectionData.ga_plan_image,
          location:
            sectionData.location && sectionData.location.color != "red"
              ? JSON.stringify({
                  x: sectionData.location.x,
                  y: sectionData.location.y,
                })
              : null,
          subFolders: this.currentSection.subFolders.map((v) => ({
            id: v.id || null,
            folder_name: v.folder_name,
            location:
              v.location && v.location.color != "red"
                ? JSON.stringify({ x: v.location.x, y: v.location.y })
                : null,
          })),
        },
      ];

      let formData = new FormData();
      formData.append("vessel_id", vessel_id);
      foldersPayload.forEach((folder, folder_index) => {
        if (folder.id) {
          formData.append(`folders[${folder_index}][id]`, folder.id);
        }
        formData.append(
          `folders[${folder_index}][folder_name]`,
          folder.folder_name
        );
        if (folder.imageBlob)
          formData.append(
            `folders[${folder_index}][imageBlob]`,
            folder.imageBlob
          );

        if (folder.ga_plan_image)
          formData.append(
            `folders[${folder_index}][ga_plan_image]`,
            folder.ga_plan_image
          );

        if (folder.location)
          formData.append(
            `folders[${folder_index}][location]`,
            folder.location
          );

        folder.subFolders.forEach((subfolder, subFolderIndex) => {
          if (subfolder.id) {
            formData.append(
              `folders[${folder_index}][subFolders][${subFolderIndex}][id]`,
              subfolder.id
            );
          }
          formData.append(
            `folders[${folder_index}][subFolders][${subFolderIndex}][folder_name]`,
            subfolder.folder_name
          );
          if (subfolder.location)
            formData.append(
              `folders[${folder_index}][subFolders][${subFolderIndex}][location]`,
              subfolder.location
            );
        });
      });

      const res = await this.getHTTPPostResponse(
        `projects/${project_id}/folder/subfolder/create`,
        formData
      );
      return res && res.status == 200 ? res.data.folders[0] : false;
    },

    async uploadImages(file, index, subFolder) {
      const formData = new FormData();
      formData.append(`ship_images[0]`, file);
      const project_id = this.project ? this.project.id : null;
      const sub_folder_id = subFolder.id;
      const response = await this.getHTTPPostResponse(
        `projects/${project_id}/subfolder/${sub_folder_id}/image/upload`,
        formData
      );
      if (response.status == 200) {
        this.selectedImages[index].isUploading = false;
        const images = response.data.images;
        const updatedSubFolder = response.data.subFolder;
        const filteredFiles = this.folderView.files.filter(
          (v) => v.index != index
        );
        const existingFilenames = new Set(
          filteredFiles.map((v) => this.getImageName(v.original || v.thumbnail))
        );
        const newImages = images.filter(
          (img) => !existingFilenames.has(this.getImageName(img.original || img.thumbnail))
        );
        const sortedFiles = [...filteredFiles, ...newImages].sort((a, b) => {
          const nameA = this.getImageName(a.original || a.thumbnail).toLowerCase();
          const nameB = this.getImageName(b.original || b.thumbnail).toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.folderView = {
          ...this.folderView,
          files: sortedFiles,
        };
        const subIndex = this.sections[this.sectionIndex].subFolders.findIndex(
          (v) => v.id === updatedSubFolder.id
        );
        if (subIndex > -1) {
          this.sections[this.sectionIndex].subFolders[subIndex].file_count =
            updatedSubFolder.file_count;
        }
        const sectionTotal = this.sections[this.sectionIndex].subFolders.reduce(
          (sum, sf) => sum + (sf.file_count || 0), 0
        );
        this.sections[this.sectionIndex].file_count = sectionTotal;
      }
    },

    async uploadImages_backup(formData, subFolder) {
      const project_id = this.project.id;
      const sub_folder_id = subFolder.id;
      this.$vs.loading();
      const response = await this.getHTTPPostResponse(
        `projects/${project_id}/subfolder/${sub_folder_id}/image/upload`,
        formData
      );
      this.$refs.fileInput.value = null;
      this.$vs.loading.close();

      if (response && response.status == "200") {
        this.$vs.notify({
          title: "Success",
          text: "Image uploaded successfully",
          color: "success",
          position: "top-right",
        });
        const images = response.data.images;
        if (images.length)
          this.currentImage = {
            url: images[0].thumbnail || images[0].original,
            index: 0,
          };
        else this.currentImage = null;
        this.folderView = {
          ...this.folderView,
          files: response.data.images,
        };
      }
    },
    openFileDialog() {
      this.$refs.fileInput.click();
    },
    showFullImage(file, index) {
      const { original, thumbnail } = file;
      const imageUrl = original || thumbnail;

      this.$vs.loading({ type: "corners" });

      const img = new Image();
      img.onload = () => {
        this.sliderImageIndex = index;
        this.currentImage = {
          url: imageUrl,
          index: index,
          name: `SID${String(index + 1).padStart(3, '0')} - ${this.getImageName(imageUrl)}`,
        };
        this.$vs.loading.close();
      };
      img.onerror = () => {
        console.error("Failed to load image:", imageUrl);
        this.$vs.loading.close();
      };
      img.src = imageUrl;
    },
    changeImage(step) {
      const newIndex = this.currentImage.index + step;
      const originalImages = this.getOriginalImageUrlWithIndex;

      if (newIndex >= 0 && newIndex < originalImages.length) {
        this.$vs.loading({
          type: "corners",
        });

        const newImage = originalImages[newIndex];
        const img = new Image();

        img.onload = () => {
          this.currentImage = newImage;
          this.$vs.loading.close();
        };

        img.onerror = () => {
          console.error("Failed to load image:", newImage.url);
          this.$vs.loading.close();
        };

        img.src = newImage.url;
      }
    },
    async changeSubFolderStatus(status, folder) {
      const project_id = this.project ? this.project.id : null;
      const sub_folder_id = folder.id;
      const folder_id = this.currentSection.id;
      const payload = {
        status,
      };
      this.$vs.loading();
      const response = await this.getHTTPPutResponse(
        `projects/${project_id}/folder/${folder_id}/subfolder/${sub_folder_id}/change-status`,
        payload
      );
      if (response) {
        const _id = folder._id;
        const index = this.sections[this.sectionIndex].subFolders.findIndex(
          (v) => v._id === _id
        );
        this.sections[this.sectionIndex].subFolders[index].status = status;
      }
      this.$vs.loading.close();
    },
    activeFolders(data) {
      return data.filter((v) => !(v.status === "N"));
    },
    archiveFolders(data) {
      return data.filter((v) => v.status === "N");
    },
    indexFindFolder(folder) {
      const _id = folder._id;
      const folders = this.sections[this.sectionIndex].subFolders;
      const index = this.activeFolders(folders).findIndex((v) => v._id === _id);
      return index > -1 ? index : "N/A";
    },
    indexFindSection(section) {
      const _id = section._id;
      const index = this.sections.findIndex((v) => v._id === _id);
      return index > -1 ? index : "N/A";
    },
    removeFile(file, index) {
      this.folderNamePopup.title = "Delete Image";
      this.folderNamePopup.message =
        "Are you confirm want to Delete this Image?";
      this.folderNamePopup.action = "deleteInsImage";
      this.folderNamePopup.info = { file, index };
      this.folderNamePopup.buttons = ["Cancel", "Delete"];
      this.folderNamePopup.isShow = true;
    },
    async deleteInsImage(info) {
      const project_id = this.project ? this.project.id : null;
      this.$vs.loading();
      const { file, index } = info;
      const payload = Object.keys(file).map((key) => file[key]);
      const uniqueUrl = payload.reduce(function (acc, curr) {
        if (!acc.includes(curr)) acc.push(curr);
        return acc;
      }, []);
      const response = await this.getHTTPPostResponse(
        `projects/${project_id}/inspection/image/delete`,
        { urls: [...uniqueUrl], subfolder_id: this.folderView.id }
      );
      this.$vs.loading.close();
      if (this.sliderImageIndex === index) this.currentImage = null;
      this.folderNamePopup.isShow = false;
      if (response) {
        this.folderView.files.splice(index, 1);
        if (!this.folderView.files.length) {
          this.currentImage = null;
        }
        const subIndex = this.sections[this.sectionIndex].subFolders.findIndex(
          (v) => v.id === this.folderView.id
        );
        if (subIndex > -1 && this.sections[this.sectionIndex].subFolders[subIndex].file_count > 0) {
          this.sections[this.sectionIndex].subFolders[subIndex].file_count -= 1;
        }
        const sectionTotal = this.sections[this.sectionIndex].subFolders.reduce(
          (sum, sf) => sum + (sf.file_count || 0), 0
        );
        this.sections[this.sectionIndex].file_count = sectionTotal;
      }
    },
    startDrag(e) {
      this.dragging = true;
      this.startX = e.clientX + this.right;
      this.startY = e.clientY - this.top;
      document.addEventListener("mousemove", this.move);
      document.addEventListener("mouseup", this.stopDrag);
    },
    stopDrag() {
      this.dragging = false;
      document.removeEventListener("mousemove", this.move);
      document.removeEventListener("mouseup", this.stopDrag);
    },
    move(e) {
      if (this.dragging) {
        this.top = e.clientY - this.startY;
        this.right = this.startX - e.clientX;
      }
    },
    generateRandomID() {
      return `${Date.now()}${Math.floor(Math.random() * 100)}`;
    },
    showImageModal(url) {
      this.imageModal.isShow = !this.imageModal.isShow;
      if (this.imageModal.isShow) {
        this.imageModal.url = url || "";
      }
    },
    getImageName(url) {
      if (!url) return '';
      const clean = url.split('?')[0];
      const filename = clean.split('/').pop();
      return filename.replace(/^thumbnail__/i, '');
    },
    resetFormDirty() {
      this.isFormDirty = false;
    },
  },
};
</script>
<style lang="css" scoped>
.folder-card-bg {
  background-image: url('/foldericon.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.scroll-container {
  overflow-x: auto;
  padding-bottom: 10px;
}
.scrollable-content {
  display: inline-block;
}
.folder-card {
  display: flex;
  flex-direction: column;
  width: 225px; /* Set your desired width */
  height: 150px;
  margin: 5px; /* Set margin between images */
}
.folder-name {
  white-space: wrap;
  word-wrap: break-word;
  /* overflow: hidden;
  text-overflow: ellipsis; */
}
.file-count-label {
  font-size: 15px;
  font-weight: 500;
  color: #495057;
  margin-top: 4px;
}
.thumbnail-filename {
  font-size: 14px;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
  margin: 4px auto 0;
  cursor: default;
}
.viewer-filename {
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.3px;
  margin-top: 4px;
}
.image-container {
  position: relative;
}

.yellow-pin::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 30px;
  height: 30px;
  background-color: #ec9a29;
  border-radius: 50% 50% 50% 0;
  z-index: -1;
}

.red-pin::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 30px;
  height: 30px;
  background-color: red;
  border-radius: 50% 50% 50% 0;
  z-index: -1;
}

.marker {
  position: absolute;
  background-color: red;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.legend {
  position: absolute;
  background: #ffffff; /* Cleaner background for readability */
  border: 1px solid #d1d5db; /* Light gray border for subtle contrast */
  border-radius: 8px;
  min-width: 180px;
  max-width: 250px;
  max-height: 400px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08); /* Soft shadow for depth */
  overflow-y: auto;
  font-family: "Inter", "Arial", sans-serif; /* Modern font */
  color: #374151; /* Dark gray for text */
  z-index: 999;
  transition: all 0.3s ease-in-out;
}

/* Header */
.legend-header {
  padding: 12px 14px;
  background: #f9fafb; /* Light header background */
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.legend-header h4 {
  margin: 0;
  font-size: 14px;
  color: #111827;
}

.legend-header span {
  font-size: 13px;
  color: #2563eb; /* Blue for interactive element */
  cursor: pointer;
  font-weight: 500;
}

.legend-header span:hover {
  text-decoration: underline;
}

/* Resizer & Scroll */
.resizer {
  padding: 10px 14px;
  background: #fff;
}

/* Items */
.legend-item {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  padding: 6px 0;
  border-bottom: 1px solid #f3f4f6;
  transition: background 0.2s;
}

.legend-item:last-child {
  border-bottom: none;
}

.legend-item:hover {
  background: #f9fafb; /* Hover effect for better UX */
  cursor: default;
}

/* Warning state */
.legend-item.text-warning {
  color: #f59e0b; /* Amber for warning */
}

.pin {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  transition: transform 0.3s ease, filter 0.3s ease;
  cursor: pointer;
}

.delete-image {
  position: absolute;
  top: 5px;
  right: 5px;
}

.custom-input-image {
  opacity: 0;
  position: absolute;
  z-index: -1;
}

.scroll-container {
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 10px;
}

.fixed-card {
  display: inline-block;
  vertical-align: top;
}

.scrollable-content {
  display: inline-block;
}

.image-card {
  display: inline-block;
  width: 150px; /* Set your desired width */
  height: 150px;
  margin: 5px; /* Set margin between images */
  align-content: center;
}

.image {
  width: 100%;
  height: auto;
}
.folder-card .folder {
  padding: 3px;
  margin-bottom: 10px;
}
.fs-small {
  font-size: 12px;
}
.fs-medium {
  font-size: 14px;
}
.remove-btn {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  top: 5px;
  right: 10px;
  width: 25px;
  height: 25px;
  background: white;
  border-radius: 10px;
  cursor: pointer;
  color: red;
}

.cursor-grab {
  cursor: grab;
}
.vs-button:disabled {
  cursor: not-allowed;
}
.resizer {
  margin: 5px;
  overflow: hidden;
  resize: both;
  min-width: 150px;
  max-width: 500px;
}
.legend-fix {
  width: 150px !important;
  height: 100px !important;
}
.drag-over {
  border: 2px dashed #3498db;
  background-color: #ecf7fe;
}
</style>
